import axios from '@/jslib/axios'

export const getCustomerList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/customer_list',
    params
  })
}
export const getCustomerReferrerList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referrer_list',
    params
  })
}

export const createAccount = data => {
  return axios({
    method: 'post',
    url: '/admin/account/create',
    data
  })
}

export const editAccount = data => {
  return axios({
    method: 'post',
    url: '/admin/account/edit',
    data
  })
}

export const getInsurerList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/insurer_list',
    params
  })
}

export const getAccountDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/account/detail',
    params
  })
}

export const getAccountQuoteList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/quote/list',
    params
  })
}

export const getAccountPolicyList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/policy/list',
    params
  })
}

export const getAccountTicketList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/ticket/list',
    params
  })
}

export const getAccountReferralList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/rewards/list',
    params
  })
}

export const getAccountMessageList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/message/list',
    params
  })
}

// 分配 cs
export const setAccountCs = data => {
  return axios({
    method: 'put',
    url: '/admin/account/cs/set',
    data
  })
}

export const addAccountRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/account/remark/add',
    data
  })
}

export const getAccountClientWallet = ({ client_id }) => {
  return axios({
    method: 'get',
    url: `/admin/account/client/wallet/${client_id}`
  })
}

// 发送修改密码 Send Password reset Link
export const sendPasswordRestList = data => {
  return axios({
    method: 'post',
    url: '/admin/account/send/reset/link',
    data
  })
}
export const approveAccount = data=>{
  return axios({
    method: 'post',
    url: '/admin/account/approved/certificate',
    data
  })
}

export const resendEmailApprove = params=>{
  return axios({
    method: 'get',
    url: '/admin/account/resend/gift/mail',
    params
  })
}
export const addUploadRequest = data=>{
  return axios({
    method: 'post',
    url: '/admin/account/upload/request',
    data
  })
}
export const sendUploadRequest = data=>{
  return axios({
    method: 'post',
    url: '/admin/account/upload/request/send',
    data
  })
}
export const getUploadRequestList = params=>{
  return axios({
    method: 'get',
    url: '/admin/account/upload/request/list',
    params
  })
}
export const delAccountRequest = data=>{
  return axios({
    method: 'delete',
    url: '/admin/account/upload/request/del',
    data
  })
}
export const checkCompanyEmail = data=>{
  return axios({
    method: 'post',
    url: '/admin/account/company/check',
    data
  })
}
export const sendCompanyEmail = data=>{
  return axios({
    method: 'post',
    url: '/admin/account/company/change/send',
    data
  })
}
export const multiCompanyResend = data=>{
  return axios({
    method: 'post',
    url: '/admin/account/company/multi/resend',
    data
  })
}
export const changePassword = data => {
  return axios({
    method: 'post',
    url: '/admin/change/password',
    data
  })
}

export const resendEmail = params => {
  return axios({
    method: 'get',
    url: '/admin/account/resend/gift/mail',
    params
  })
}

export const sendCode = data => {
  return axios({
    method: 'post',
    url: '/admin/account/mobile/edit/send',
    data
  })
}

export const verifyCode = data => {
  return axios({
    method: 'post',
    url: '/admin/account/mobile/edit/verify',
    data
  })
}

export const draftEmailCancel = data => {
  return axios({
    method: 'post',
    url: '/admin/account/draft/email/cancel',
    data
  })
}

export const aliUnbind = data => {
  return axios({
    method: 'post',
    url: '/admin/ali/unbind',
    data
  })
}

export const getSmsTemplate = params => {
  return axios({
    method: 'get',
    url: '/admin/sms/template',
    params
  })
}

export const getInsurerPlanList = params => {
  return axios({
    method: 'get',
    url: '/admin/insurers/plan/list',
    params
  })
}

export const getInsurerPlanDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/insurers/plan/detail',
    params
  })
}

export const insurerUpoloadFile = data => {
  return axios({
    method: 'post',
    url: '/admin/insurers/upload/policy/file',
    data
  })
}

export const insurerEditFile = data => {
  return axios({
    method: 'post',
    url: '/admin/insurers/file/data/edit',
    data
  })
}

export const insurerDelFile = data => {
  return axios({
    method: 'delete',
    url: '/admin/insurers/file/del',
    data
  })
}
export const addRate = data => {
  return axios({
    method: 'post',
    url: '/admin/insurers/policy/commission',
    data
  })
}

export const editRate = data => {
  return axios({
    method: 'post',
    url: '/admin/insurers/commission/data/edit',
    data
  })
}

export const delRate = data => {
  return axios({
    method: 'delete',
    url: '/admin/insurers/commission/del',
    data
  })
}


export const addDescription = data => {
  return axios({
    method: 'post',
    url: '/admin/account/description/add',
    data
  })
}

export const editUserBlocks = data => {
  return axios({
    method: 'post',
    url: 'admin/account/blocks/edit',
    data
  })
}


export const flagEdit = data => {
  return axios({
    method: 'post',
    url: '/admin/account/flag/edit',
    data
  })
}
export const importBlockList = data => {
  return axios({
    method: 'post',
    url: '/admin/account/blocks/import',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}
export const exportBlockList = data => {
  return axios({
    method: 'post',
    url: '/admin/account/blocks/export',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    data
  })
}
export const getLogEmailDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/log/detail',
    params
  })
}
export const getStatementList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/statement/list',
    params
  })
}
export const getDownStatementList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/statement/list',
    responseType: 'blob',
    params
  })
}
